import { connect } from 'react-redux';
import actions, { setDefFilters, setFilters } from '../../actions/AlertsBurstActions';
import { FILTERS_BURST_ALERTS } from '../../constants/SettingsKeys';

import { invalidateProject } from '../../actions/setters';
import BurstAlertsSettings from '../../components/AlertsSettings/BurstAlertsSettings';


const mapStateToProps = (state, ownProps) => {
    const {
        selectedProject
    } = state.leaksList;
    const user = state.leaksList.user;
    const initialFilters = {};
    const burstFilters = state.burst.filters;
    burstFilters.forEach((filter) => {
        if (filter.op && filter.op === 'range') {
            if (filter.from) {
                initialFilters[filter.field + '-From'] = filter.from;
            }
            if (filter.to) {
                initialFilters[filter.field + '-To'] = filter.to;
            }
        } else {
            initialFilters[filter.field] = filter.value;
        }
    });

    return Object.assign({}, {
        user,
        selectedProject,
        initialValues: initialFilters,
        optionList: state.leaksList.optionList.options
    }, ownProps);
}


const mapDispatchToProps = (dispatch, ownProps) => ({
    onSubmit: (values, dispatch, props) => {
        const {
            selectedProject,
            processFilters,
            cleanEmptyFilters
        } = props;

        var filters = processFilters(Object.assign({}, values));
        delete filters.defFilters.sortBy;
        delete filters.defFilters.sortByDir;
        dispatch(invalidateProject(selectedProject));
        dispatch(setDefFilters(filters.defFilters));
        const cleanFilters = cleanEmptyFilters(filters.filters);
        dispatch(setFilters(cleanFilters));
        dispatch(actions.fetchBurstAlerts(selectedProject));

        localStorage.setItem(FILTERS_BURST_ALERTS, JSON.stringify(filters.defFilters));
    }
});

const CBurstAlertsSettings = connect(
    mapStateToProps,
    mapDispatchToProps
)(BurstAlertsSettings);

export default CBurstAlertsSettings;
